/** Editable consignment fields (everything except the AWB / HAWB identity). */
export interface HawbDetailsValues {
  arrival_date: string | null;
  origin_station: string;
  destination: string;
  responsible_person: string;
  packages: number | string;
  weight_kg: number | string;
  storage_fee_paid: boolean;
  blocked: boolean;
  has_pick_list: boolean;
}

export const MAX_PACKAGES = 10000;
/** Matches the varchar(255) columns of the optional free-text fields. */
export const MAX_FREE_TEXT = 255;

/** Shared validation rules for the editable fields (create + edit). */
export const hawbDetailsValidation = {
  origin_station: (value: string) => (value.trim().length > 16 ? "manifests.form.originTooLong" : null),
  destination: (value: string) =>
    value.trim().length > MAX_FREE_TEXT ? "manifests.form.destinationTooLong" : null,
  responsible_person: (value: string) =>
    value.trim().length > MAX_FREE_TEXT ? "manifests.form.responsiblePersonTooLong" : null,
  packages: (value: number | string) =>
    typeof value === "number" && Number.isInteger(value) && value >= 1 && value <= MAX_PACKAGES
      ? null
      : "manifests.form.packagesInvalid",
  weight_kg: (value: number | string) =>
    value === "" || (typeof value === "number" && value >= 0) ? null : "manifests.form.weightInvalid",
};

/** Form values → API payload (empty strings become null). */
export const toHawbPayload = (values: HawbDetailsValues) => ({
  arrival_date: values.arrival_date || null,
  origin_station: values.origin_station.trim() || null,
  destination: values.destination.trim() || null,
  responsible_person: values.responsible_person.trim() || null,
  packages: typeof values.packages === "number" ? values.packages : Number(values.packages),
  weight_kg: values.weight_kg === "" ? null : Number(values.weight_kg),
  storage_fee_paid: values.storage_fee_paid,
  blocked: values.blocked,
  has_pick_list: values.has_pick_list,
});
